import { render } from "./CommissionCalculation.vue?vue&type=template&id=868608da&scoped=true"
import script from "./CommissionCalculation.vue?vue&type=script&lang=js"
export * from "./CommissionCalculation.vue?vue&type=script&lang=js"

import "./CommissionCalculation.vue?vue&type=style&index=0&id=868608da&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-868608da"]])

export default __exports__